/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Type_Chip_LabelInputs */

const en_clients_type_chip_label = /** @type {(inputs: Clients_Type_Chip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client type`)
};

const pt_br2_clients_type_chip_label = /** @type {(inputs: Clients_Type_Chip_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de cliente`)
};

/**
* | output |
* | --- |
* | "Client type" |
*
* @param {Clients_Type_Chip_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_type_chip_label = /** @type {((inputs?: Clients_Type_Chip_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Type_Chip_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_type_chip_label(inputs)
	return pt_br2_clients_type_chip_label(inputs)
});